export const widgetDefaults = {
  pageName: 'booking_my_bookings_widget',
};

export const settingsDefaults = {
  referralInfo: 'members_area',
};
